import { Typography } from "@mui/material";
import moment from "moment";
import { DemoDetailResponse } from "src/services/admin/queries/NetTypes";

export default function DateDemo({ createdAt }: DemoDetailResponse) {
	return (
		<Typography variant='subtitle2' sx={{ ml: 2 }}>
			{moment(createdAt).format("lll")}
		</Typography>
	);
}
